// extracted by mini-css-extract-plugin
export var actionButton = "_ps-0";
export var actionMenuContainer = "_ps-i";
export var bubble = "_ps-2";
export var bubbleActionMenu = "_ps-j";
export var bubbleContext = "_ps-6";
export var bubbleItems = "_ps-7";
export var customer = "_ps-3";
export var divider = "_ps-8";
export var fileList = "_ps-9";
export var hiddenComment = "_ps-o";
export var infoAbove = "_ps-a";
export var internal = "_ps-4";
export var lightActionButton = "_ps-1";
export var link = "_ps-b";
export var merchant = "_ps-5";
export var message = "_ps-c";
export var profilePicture = "_ps-e";
export var quillToolbarContainer = "_ps-f";
export var senderDate = "_ps-g";
export var senderDateCustomer = "_ps-h";
export var senderName = "_ps-d";
export var time = "_ps-k";
export var uploadedImage = "_ps-l";
export var username = "_ps-m";
export var xsmall = "_ps-n";